import React, { useLayoutEffect, useRef } from 'react';
import cx from 'classnames';

import { SELECTION } from 'js/utils/question-selection';

/**
 * A switch for a group whose members can each be on or off. It shows on, off
 * or mixed (knob centered) and reports mixed to assistive tech through the
 * native indeterminate state.
 *
 * Like reactstrap's CustomInput, `label` goes in the clickable label and
 * children follow it inside the control, where they can float to its edge.
 */
export function TriStateSwitch({
  id,
  state,
  onChange,
  disabled = false,
  size,
  className,
  label,
  children,
  ...props
}) {
  const inputRef = useRef(null);
  const mixed = state === SELECTION.MIXED;

  useLayoutEffect(() => {
    inputRef.current.indeterminate = mixed;
  }, [mixed]);

  return (
    <div
      className={cx(
        'custom-control custom-switch',
        { [`custom-switch-${size}`]: size },
        className
      )}
    >
      <input
        type="checkbox"
        className="custom-control-input"
        id={id}
        ref={inputRef}
        checked={state === SELECTION.ON}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      <label className="custom-control-label" htmlFor={id}>
        {label}
      </label>
      {children}
    </div>
  );
}

export default TriStateSwitch;
